<template>
  <div class="action">
    <button @click="isOpen = !isOpen" class="button is-primary" slot="botton">View Details</button>
    <div :class="['modal', {'is-active': isOpen}]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head" header-class="justify-content-center">
          <!-- <p class="modal-card-title">View User</p> -->
          <button @click="cancel" class="delete" aria-label="close"></button>
          <div class = 'make-c'>
          <label class='label-h modal-card-title'>Client Details</label>
          </div>
          <!-- <p class="modal-card-title">View User</p> -->
        </header>
         <section class="modal-card-body">

    <div class="container">
         <label class='label'>Personal Information</label>
         <hr class="solid">
        <div class="columns is-multiline is-mobile">
            <div class="column is-half">
                <!-- <label class="font-weight-bold">Name: <span>{{form.first_name}} {{form.middle_name}} {{form.last_name}}</span></label><br> -->
                <label> <span class="inner-data">Name: </span><span>{{form.english_name}} ({{form.nepali_name}})</span></label><br>
                <label> <span class="inner-data">Gender: </span><span>{{ form.gender }}</span></label><br>
                <label> <span class="inner-data">Citizenship Number:</span> <span>{{ form.citizenship_number }}</span></label><br>
             </div>
            <div class="column is-half">
                <label> <span class="inner-data">Birth Date:</span><span>{{ form.birth_date | formatDateShort }}</span></label><br>
                <label> <span class="inner-data">Father's Name: </span><span>{{ form.father_name }}</span></label><br>
                <label> <span class="inner-data">Grandfather Name: </span><span>{{ form.grandfather_name }}</span></label><br>
            </div>
        </div>        
    </div>
    <div class="container">
         <label class='label'>Contact Information</label>
         <hr class="solid">
        <div class="columns is-multiline is-mobile">
            <div class="column is-half">
                <label> <span class="inner-data"> District: </span><span>{{ form.district }}</span></label><br>
                <label> <span class="inner-data"> Mobile Number:</span> <span>{{ form.mobile_number }}</span></label><br>
                <label> <span class="inner-data"> Phone Number:</span> <span>{{ form.phone_number }}</span></label><br>
                <label> <span class="inner-data"> Permanent Address:</span> <span>{{ form.permanent_address }}</span></label><br>
             </div>
            <div class="column is-half">
                <label> <span class="inner-data"> Current Address: </span><span>{{ form.current_address }}</span></label><br>
                <label> <span class="inner-data"> Temporary Address:</span> <span>{{ form.temporary_address }}</span></label><br>
                <label> <span class="inner-data"> Bank Name:</span> <span>{{ form.bank }}</span></label><br>
                <label> <span class="inner-data"> Account Number: </span><span>{{ form.account_number }}</span></label><br>
            </div>
        </div>        
    </div>
    <div class="container">
         <label class='label'>Beneficial Information</label>
         <hr class="solid">
        <div class="columns is-multiline is-mobile">
            <div class="column">
                <label> <span class="inner-data">Beneficiary Name: </span><span>{{ form.beneficiary_name }}</span></label><br>
                <label> <span class="inner-data">Relationship:</span> <span>{{ form.relationship }}</span></label><br>
                <label> <span class="inner-data">Beneficiary Contact:</span> <span>{{ form.beneficiary_contact }}</span></label><br>
             </div>
        </div>        
    </div>
       <div class="container">
         <label class='label'>Official Information</label>
         <hr class="solid">
        <div class="columns is-multiline is-mobile">
            <div class="column is-half">
                <label> <span class="inner-data">Registration Date: </span><span>{{ form.registration_date | formatDateShort }}</span></label><br>
                <label> <span class="inner-data">Referred By: </span><span>{{ form.referred_by }}</span></label><br>
                <label> <span class="inner-data">Verified By: </span><span>{{ form.verifiedBy }}</span></label><br>
                <label> <span class="inner-data">Code No.: </span><span>{{ form.code_no }}</span></label><br>
                <label> <span class="inner-data">Office Code No.: </span><span>{{ form.office_code_no }}</span></label><br>
                <label> <span class="inner-data">Card Status: </span><span>{{ form.card_status }}</span></label><br>
             </div>
             <div class="column is-half">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-half">
                <img :src="form.fingerprint_left">
                  </div>
                  <div class="column is-half">
                <img :src="form.fingerprint_right">
                  </div>
                </div>
             </div>
        </div>        
    </div>
     <div class="container">
         <label class='label'>Photo Information</label>
         <hr class="solid">
        <div class="columns is-multiline is-mobile">
            <div class="column is-half">
              <span class="inner-data">Voucher: </span>
              <img :src="form.voucher_scan">
              <span class="inner-data">Citizenship Front: </span>
              <img :src="form.citizenship_scan_front">
              <span class="inner-data">Photo: </span>
              <img :src="form.photo_scan">
              <span v-if="form.signature_scan && form.form_scan" class="inner-data">Signature: </span>
              <img :src="form.signature_scan" v-if="form.signature_scan && form.form_scan">
             </div>
            <div class="column is-half">
              <span class="inner-data">Hakwala: </span>
              <img :src="form.hakwala_scan">
              <span class="inner-data">Citizenship Back: </span>
              <img :src="form.citizenship_scan_back">
              <span v-if="form.form_scan" class="inner-data">Form: </span>
              <img :src="form.form_scan">
              <span v-if="form.signature_scan && !form.form_scan" class="inner-data">Signature: </span>
              <img :src="form.signature_scan"  v-if="form.signature_scan && !form.form_scan">
            </div>
        </div>        
    </div>
        </section> 
      </div>
    </div>
  </div>
</template>


<script>
import axiosInstance from '../../services/axios';
import {
  required,
  email,
  minLength,
  url,
  sameAs
} from 'vuelidate/lib/validators';
import { getAPIEndpoint } from '../../helpers';
export default {
  data() {
    return {
      form: {
            nepali_name: this.selectedCitizen.full_name,
            english_name: this.selectedCitizen.english_name,
            first_name: this.selectedCitizen.first_name,
            middle_name: this.selectedCitizen.middle_name,
            last_name: this.selectedCitizen.last_name,
            gender: this.selectedCitizen.gender,
            citizenship_number: this.selectedCitizen.citizenship_number,
            birth_date: this.selectedCitizen.birth_date,
            father_name: this.selectedCitizen.father_name,
            grandfather_name: this.selectedCitizen.grandfather_name,
            district: this.selectedCitizen.district,
            mobile_number: this.selectedCitizen.mobile_number,
            phone_number: this.selectedCitizen.phone_number,
            permanent_address: this.selectedCitizen.permanent_address,
            current_address: this.selectedCitizen.current_address,
            temporary_address: this.selectedCitizen.temporary_address,
            bank: this.selectedCitizen.bank,
            account_number: this.selectedCitizen.account_number,
            beneficiary_name: this.selectedCitizen.beneficiary_name,
            relationship: this.selectedCitizen.relationship,
            beneficiary_contact: this.selectedCitizen.beneficiary_contact,
            registration_date: this.selectedCitizen.registration_date,
            referred_by: this.selectedCitizen.referred_by,
            entry_by: this.selectedCitizen.entry_by,
            fingerprint_left: this.selectedCitizen.fingerprint_left,
            fingerprint_right: this.selectedCitizen.fingerprint_right,
            verifiedBy: this.selectedCitizen.verifiedBy,
            code_no: this.selectedCitizen.code_no,
            office_code_no: this.selectedCitizen.office_code_no,
            form_scan: this.selectedCitizen.form_scan,
            photo_scan: this.selectedCitizen.photo_scan,
            citizenship_scan_front: this.selectedCitizen.citizenship_scan_front,
            citizenship_scan_back: this.selectedCitizen.citizenship_scan_back,
            voucher_scan: this.selectedCitizen.voucher_scan,
            hakwala_scan: this.selectedCitizen.hakwala_scan,
            card_status: this.selectedCitizen.card_status,
            signature_scan: this.selectedCitizen.signature_scan
        // quantity: this.selectedOrder.quantity,
        // category: this.selectedProduct.category._id,
        // state: this.selectedOrder.state,

        // featuredImage: this.selectedProduct.featuredImage,
        // _id: this.selectedOrder._id
      },
      // photo1: '',
      // photo2: ''
      //   uploadPercent: 0,
      //   file: null
    };
  },
  // validations: {
  //   form: {
  //     quantity: {
  //       required
  //     }
  //     // state: {
  //     //   required
  //     // }
  //   }
  // },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    selectedCitizen: {
      type: Object,
      required: true
    }
  },

  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    // buttonLabel() {
    //   return !this.file ? 'Pick a file' : 'Pick another file';
    // },
    citizens() {
      return this.$store.state.citizens.items;
    }
  },
    created() {
      this.photo1 =  this.$store.state.citizens.fingerprint_left
      this.photo2 = this.$store.state.citizens.fingerprint_right
  },
  methods: {
    // updateOrderPressed() {
    //   console.log(this.form);
    //   this.$v.form.$touch();

    //   this.$store
    //     .dispatch('orders/updateOrderWithId', this.form)
    //     .then(() => {
    //       this.isOpen = false;
    //       this.$emit('cancel');

    //       this.$buefy.snackbar.open({
    //         message: 'Order Updated Successfully',
    //         queue: false
    //       });
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // upload(file) {
    //   this.$emit('input', file);

    //   this.uploadPercent = 0;

    //   let formData = new FormData();

    //   formData.append('image', file);

    //   axiosInstance
    //     .post(`${getAPIEndpoint()}/dev/image-upload`, formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       },
    //       onUploadProgress: this.progressEvent
    //     })
    //     .then(res => {
    //       this.form.featuredImage = res.data.imageUrl;
    //     })
    //     .catch(err => {
    //       this.$buefy.toast.open({
    //         message: `Error: ${err.message}`,
    //         type: 'is-danger'
    //       });
    //     });
    // },
    // progressEvent(progressEvent) {
    //   this.uploadPercent = Math.round(
    //     (progressEvent.loaded * 100) / progressEvent.total
    //   );
    // },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>


<style scoped>
/* .modal-card {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
} */


/* .container {
  width: 50px;
  margin: 0 80%;
} */
.modal-card,
    .modal-content {
        margin: 0 20px;
        max-height: 100vh;
        overflow: auto;
        position: relative;
        width: calc(100% - 2em);
    }

.make-c{
  position:relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h2{
  font-size: 1.5em;
  color: blue;
}
.solid{
  border-top: 1px solid gray;
  margin-top: 10px;
}
.label{
  font-size: 1.5em;
  font-weight: 400;
}
.inner-data{
  font-weight: 600
}


.label-h{
  font-size: 1.7em;
  font-weight: 500;
}

.level .img {
  right: -112px;
  position: absolute;
  border-radius: 30px;
}
.container{
    margin-bottom: 5%;
    font-size: 1em;
}
/* .modal-card-body{
  background-image: url('https://mig-bucket.s3.ap-south-1.amazonaws.com/mig_holdings_a4.jpg');
  height: 50%;
  width: 50%;
} */
</style>